export enum CarrotPlanMediaTypeId {
  Article = "article",
  Video = "video",
  Guide = "guide",
  Group = "groupSession"
}

type CarrotPlanMediaType = {
  stepVal: string
  replacement: string
  displayNameWithArticle: string
  menuItemId: string
}

export const CarrotPlanMediaTypes: { [key in CarrotPlanMediaTypeId]: CarrotPlanMediaType } = {
  [CarrotPlanMediaTypeId.Article]: {
    stepVal: 'Read "[article title]"',
    replacement: "[article title]",
    displayNameWithArticle: "an article",
    menuItemId: "6P6c1JhtDMcVIk9DE8u1Ca"
  },
  [CarrotPlanMediaTypeId.Video]: {
    stepVal: 'Watch "[video title]"',
    replacement: "[video title]",
    displayNameWithArticle: "a video",
    menuItemId: "6cjqRZ2djmEpFH1eD0elbX"
  },
  [CarrotPlanMediaTypeId.Guide]: {
    stepVal: 'Explore "[guide title]"',
    replacement: "[guide title]",
    displayNameWithArticle: "a guide",
    menuItemId: "20nMPmMswstXjq3xdBXEzi"
  },
  [CarrotPlanMediaTypeId.Group]: {
    stepVal: 'Attend a group session on "[group title]"',
    replacement: "[group title]",
    displayNameWithArticle: "a group",
    menuItemId: "1D4fLW2eWfCnRGd3v0z2Wx"
  }
}

export const CarrotPlanMediaStepVals = [
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Article].stepVal,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Video].stepVal,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Guide].stepVal,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Group].stepVal
]

export const CarrotPlanMediaReplacements = [
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Article].replacement,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Video].replacement,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Guide].replacement,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Group].replacement
]

export const CarrotPlanMediaMenuItemIds = [
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Article].menuItemId,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Video].menuItemId,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Guide].menuItemId,
  CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Group].menuItemId
]

export const GetCarrotPlanMediaTypeIdForStepVal = (stepVal: string): CarrotPlanMediaTypeId | null => {
  if (CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Article].stepVal === stepVal) {
    return CarrotPlanMediaTypeId.Article
  } else if (CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Video].stepVal === stepVal) {
    return CarrotPlanMediaTypeId.Video
  } else if (CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Guide].stepVal === stepVal) {
    return CarrotPlanMediaTypeId.Guide
  } else if (CarrotPlanMediaTypes[CarrotPlanMediaTypeId.Group].stepVal === stepVal) {
    return CarrotPlanMediaTypeId.Group
  }
  return null
}
